import { useQuery } from "react-query";
import { TotaisRelatorioReservas } from "../typings";
import { AxiosError } from "axios";
import http from "infra/http";
import { FiltroRelatorioReservas } from "../typings/index";

function useRelatorioReservasDashboard(
  query: FiltroRelatorioReservas,
  enabled = false
) {
  return useQuery<TotaisRelatorioReservas, AxiosError>(
    [`/v1/relatorios/reservas/dashboard`, query],
    async () => {
      const { data } = await http.get<TotaisRelatorioReservas>(
        "/v1/relatorios/reservas/dashboard",
        {
          params: query,
        }
      );

      return data;
    },
    {
      enabled
    }
  );
}

export default useRelatorioReservasDashboard;
